var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.loading)?_c('FormViewer',{attrs:{"isOwner":false,"envelope":_vm.$parent.loadedEnvelope,"recipient":_vm.$parent.loadedRecipient}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }